import React from "react";
import Main from "./Main"
import Side from "./Side"
import {
  Flex
} from 'rebass'

export default class Layout extends React.Component {
    render() {
      return (
        <Flex alignItems='strech'
          flexDirection={['column', 'row', 'row']}
          color='white'
          bg='#282c34'>
            <Side changeContent={(e) => { this.func(e); }}/>
            <Main setFunc={func => this.func = func}/>
        </Flex>
      );
    }
  }
